"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importDefault(require("styled-components"));
var SwitchToggle = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* touch-action: pan-y; */\n  position: relative;\n  width: 51px;\n  height: 32px;\n  border-radius: 30px;\n\n  transition-duration: 0.15s;\n  transition-timing-function: ease-out;\n\n  box-shadow: ", ";\n\n  background-color: ", ";\n\n  opacity: ", ";\n"], ["\n  /* touch-action: pan-y; */\n  position: relative;\n  width: 51px;\n  height: 32px;\n  border-radius: 30px;\n\n  transition-duration: 0.15s;\n  transition-timing-function: ease-out;\n\n  box-shadow: ",
    ";\n\n  background-color: ", ";\n\n  opacity: ", ";\n"])), function (props) {
    return props.checked ? "inset 0 0 0 2px #44db5e" : "inset 0 0 0 2px #666";
}, function (props) { return (props.checked ? "#44db5e" : "#0d0d0d"); }, function (props) { return (props.disabled ? "0.3" : "1"); });
var SwitchHandle = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  box-sizing: border-box;\n  position: absolute;\n  border-radius: 28px;\n  height: 28px;\n  width: 28px;\n  background-color: white;\n  top: 2px;\n\n  transition-duration: 0.15s;\n  transition-timing-function: cubic-bezier(0.59, 0.01, 0.5, 0.99);\n\n  box-shadow: ", ";\n\n  left: ", ";\n"], ["\n  box-sizing: border-box;\n  position: absolute;\n  border-radius: 28px;\n  height: 28px;\n  width: 28px;\n  background-color: white;\n  top: 2px;\n\n  transition-duration: 0.15s;\n  transition-timing-function: cubic-bezier(0.59, 0.01, 0.5, 0.99);\n\n  box-shadow: ",
    ";\n\n  left: ", ";\n"])), function (props) {
    return props.checked
        ? "0 3px 2px rgba(0, 0, 0, 0.25)"
        : "0 0 1px 0 rgba(0, 0, 0, 0.25), 0 3px 2px rgba(0, 0, 0, 0.25)";
}, function (props) { return (props.checked ? "21px" : "1px"); });
function Switch(props) {
    return (jsx_runtime_1.jsx(SwitchToggle, __assign({ onClick: props.onClick, checked: props.checked, disabled: props.disabled }, { children: jsx_runtime_1.jsx(SwitchHandle, { checked: props.checked, disabled: props.disabled }, void 0) }), void 0));
}
exports.Switch = Switch;
var templateObject_1, templateObject_2;
//# sourceMappingURL=switch.js.map